import angular from "angular";

angular
    .module('app')
    .component('courseGroupLessons', {
        template: require('./course-group-lessons.html'),
        controller: ['$http', 'Notifier', '$uibModal', 'moment', controller],
        bindings: {
            course: '<',
            courseGroup: '<',
            chapters: '<',
            courseGroupAndLessons: '<',
        }
    });

function controller($http, Notifier, $uibModal, moment) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = '20';

    $ctrl.id = null;
    $ctrl.course = null;
    $ctrl.status = null;

    $ctrl.$onInit = function () {
        setLessonStatuses();
    };

    function setLessonStatuses() {
        $ctrl.chapters.forEach(function (chapter) {
            chapter.lessons.forEach(function (lesson) {
                let t = $ctrl.courseGroupAndLessons.find(v => v.lesson_id == lesson.id);
                lesson.status = t.status;
            });
        });
    }

    $ctrl.getList = function () {
        $http
            .get('/admin/course-groups/get-list', {
                params: {
                    page: $ctrl.page,
                    per_page: $ctrl.perPage,
                    id: $ctrl.id,
                    course_id: $ctrl.course ? $ctrl.course.id : null,
                    status: $ctrl.status,
                }
            })
            .then(
                function (response) {
                    $ctrl.groups = response.data.data;
                    $ctrl.total = response.data.total;
                },
                function (error) {

                }
            );
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.resetFilter = function () {
        $ctrl.page = 1;
        $ctrl.id = null;
        $ctrl.course = null;
        $ctrl.status = null;
        $ctrl.getList();
    };

    $ctrl.openAttachModal = function () {
        $uibModal
            .open({
                component: 'courseGroupStudentsAttachModal',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    },
                    courseGroup: function () {
                        return $ctrl.courseGroup;
                    }
                }
            })
            .result
            .then(
                function (students) {
                    students.forEach(function (student) {
                        student.pivot = {created_at: moment()};
                        $ctrl.students.push(student);
                    });
                },
                function (error) {

                }
            );
    };

}
